module.exports = __webpack_public_path__ + "static/media/img-center-mobile.9b2fc61e.svg";